import { Pipe, PipeTransform } from '@angular/core';

import dayjs from 'dayjs/esm';

@Pipe({
	name: 'formatMediumDate',
	standalone: false,
})
export class FormatMediumDatePipe implements PipeTransform {
	transform(day: dayjs.Dayjs | null | undefined): string {
		return day ? day.format('D MMM YYYY') : '';
	}
}
